/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Level_IntermediateInputs */

const en_us2_profile_level_intermediate = /** @type {(inputs: Profile_Level_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermediate`)
};

const pt_br2_profile_level_intermediate = /** @type {(inputs: Profile_Level_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermediário`)
};

const es_419_profile_level_intermediate = /** @type {(inputs: Profile_Level_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermedio`)
};

const pt_pt2_profile_level_intermediate = /** @type {(inputs: Profile_Level_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermédio`)
};

const fr_fr2_profile_level_intermediate = /** @type {(inputs: Profile_Level_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermédiaire`)
};

const de_de2_profile_level_intermediate = /** @type {(inputs: Profile_Level_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortgeschritten`)
};

const it_it2_profile_level_intermediate = /** @type {(inputs: Profile_Level_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermedio`)
};

/**
* | output |
* | --- |
* | "Intermediate" |
*
* @param {Profile_Level_IntermediateInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_level_intermediate = /** @type {((inputs?: Profile_Level_IntermediateInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Level_IntermediateInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_level_intermediate(inputs)
	if (locale === "es-419") return es_419_profile_level_intermediate(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_level_intermediate(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_level_intermediate(inputs)
	if (locale === "de-DE") return de_de2_profile_level_intermediate(inputs)
	if (locale === "it-IT") return it_it2_profile_level_intermediate(inputs)
	return en_us2_profile_level_intermediate(inputs)
});
export { profile_level_intermediate as "profile.level_intermediate" }